import { render, staticRenderFns } from "./simple-panel.vue?vue&type=template&id=c3587940&"
import script from "./simple-panel.vue?vue&type=script&lang=ts&"
export * from "./simple-panel.vue?vue&type=script&lang=ts&"
import style0 from "./simple-panel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports